module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bindTimeStamp":"Connect to timestamp"}}')
  delete Component.options._Ctor
}
